module.exports = __webpack_public_path__ + "static/media/yoti.59a2a47d.svg";